<template>
  <div class="message-board-card" :style="getPaperStyle">
    <div class="message-board-card-body">
      <div class="message-default" :class="getMessageClass"><span>{{ getMessage }}</span></div>
      <div class="name-default" :class="getNameClass"><span>—— {{ getName }}</span></div>
    </div>
  </div>
</template>

<script>
import { MessageBoardModel } from "@/models/message-board-model";

export default {
  name: "MessageBoardCard",
  props: {
    messageBoardData: {
      type: MessageBoardModel,
      required: true
    }
  },
  computed: {
    getMessage() {
      return this.messageBoardData ? this.messageBoardData.message : ""
    },
    getName() {
      return this.messageBoardData ? this.messageBoardData.name : ""
    },
    getPaper() {
      return this.messageBoardData ? this.messageBoardData.color : 0
    },
    getPaperStyle() {
      const paper = this.getPaper
      let cssStyle = ''
      switch (paper) {
        case 0:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardGreenImage}) !important;`
          break
        case 1:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardPinkImage}) !important;`
          break
        case 2:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardYellowImage}) !important;`
          break
        case 3:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardBlueImage}) !important;`
          break
        default:
          cssStyle = `background-image: url(${this.$store.getters.messageBoardGreenImage}) !important;`
      }
      return cssStyle
    },
    getPaperClass() {
      const paper = this.getPaper
      switch (paper) {
        case 0:
          return "paper-green"
        case 1:
          return "paper-pink"
        case 2:
          return "paper-yellow"
        case 3:
          return "paper-blue"
        default:
          return "paper-green"
      }
    },
    getMessageClass() {
      const message = this.getMessage
      if (message.length <= 7) {
        return "message-large"
      } else if (message.length <= 63) {
        return "message-medium"
      } else if (message.length > 63) {
        return "message-mini"
      } else {
        return ""
      }
    },
    getNameClass() {
      const name = this.getName
      if (name.length <= 7) {
        return "name-large"
      } else if (name.length <= 63) {
        return "name-medium"
      } else if (name.length > 63) {
        return "name-mini"
      } else {
        return ""
      }
    }
  },
  data() {
    return {}
  }
};
</script>

<style lang="scss" scoped>
</style>
